import { render, staticRenderFns } from "./SEOpage.vue?vue&type=template&id=1157439f"
import script from "./SEOpage.vue?vue&type=script&lang=js"
export * from "./SEOpage.vue?vue&type=script&lang=js"
import style0 from "./SEOpage.vue?vue&type=style&index=0&id=1157439f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports